<template>
  <el-row type="flex" justify="center">
    <el-col :span="20">
      <el-menu :default-active="activeIndex" class="el-menu-nav-bar" mode="horizontal">
        <el-menu-item index="1">
          <router-link to="/classroom-list">Classrooms</router-link>
        </el-menu-item>
        <el-menu-item index="2">
          <router-link :to="'/userinfo/' + $store.state.userId">User Info</router-link>
        </el-menu-item>
      </el-menu>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: "NavHeader",
  props: {
    activeIndex: String
  },
};
</script>

<style>
.el-menu-item {
  padding: 0;
}
.el-menu-item > * {
  padding: 0 20px;
  text-decoration: none;
  display: inline-block;
}
</style>